import { useMessagingContext } from '../providers/MessagingProvider'
import type { MessagingContextValue } from '../providers/MessagingProvider'

/**
 * Hook to access messaging service and state
 */
export const useMessaging = (): MessagingContextValue => {
  return useMessagingContext()
}
